import React from "react";
import { Link } from "react-router-dom";

const PageHero = ({ title, text, crumbs = [], meta }) => (
  <section className="page-hero">
    <div className="container">
      {crumbs.length > 0 && (
        <ol className="breadcrumb">
          <li><Link to="/">Ana Sayfa</Link></li>
          {crumbs.map((c) =>
            c.to ? (
              <li key={c.label}><Link to={c.to}>{c.label}</Link></li>
            ) : (
              <li key={c.label}>{c.label}</li>
            )
          )}
        </ol>
      )}
      <h1>{title}</h1>
      {text && <p>{text}</p>}
      {meta && <div className="page-hero__meta">{meta}</div>}
    </div>
  </section>
);

export default PageHero;
